import React, { useState, useLayoutEffect } from 'react';
import { useLocation } from "react-router-dom";
import { CButton, CFormInput } from '@coreui/react'
import Swal from "sweetalert2";
import axios from 'axios'
import ReactLoading from 'react-loading'
import Logo from '../assets/logo.png'
import logoActive from "../assets/LogoActiveAnimated.gif";
import mario from '../assets/mario.png'
import useSound from "use-sound";
import marioJump from "../sounds/marioJump.mp3";

import './ForgotPassword.css'

function ForgotPassword(props) {
  let [play] = useSound(marioJump)
  let [count, setCount] = useState(0)
  let location = useLocation()
  let params = new URLSearchParams(location.search)
  let [loading, setLoading] = useState(true)
  let [loading2, setLoading2] = useState(false)
  let [error, setError] = useState(false)
  let [termine, setTermine] = useState(false)
  let [userData, setUserData] = useState({})
  let [pass1, setPass1] = useState()
  let [pass2, setPass2] = useState()

  function logoHandler() {
    let temp = count

    if (count == 14) {
      play()
      document.getElementById('mario').classList.add("mario")
      setTimeout(() => { document.getElementById('mario').classList.remove("mario") }, 600);
      setCount(1)
    }
    else { temp++; setCount(temp) }
  }

  async function handleSubmit() {
    if (pass1 !== pass2) {
      Swal.fire("Las contraseñas no coinciden.");
      return;
    }

    try {
      await axios.patch(`${process.env.REACT_APP_BackURL}/changePasswordUser`, { token: userData.token, newpassword: pass1, });

      Swal.fire("Contraseña actualizada con éxito!").then(() => {
        setLoading2(false);
        setTermine(true);
      });
    } catch (err) {
      Swal.fire("Ocurrió un error, intenta de nuevo por favor.");
    }
  };

  useLayoutEffect(() => {
    const token = params.get("token");

    if (!token) {
      setError(true);
      setLoading(false);
      return;
    }

    setUserData({ token });
    setLoading(false);
  }, []);

  return (
    <>
      {
        termine ?
          <>
            <div className='contenidosForgot'>
              <br />
              <br />
              <img style={{ width: '300px' }} src={Logo} alt="" />
              <br />
              <br />
              <div style={{ width: '50%', margin: 'auto', padding: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <br />
                <img style={{ width: '300px' }} src={mario} /> <br />
                <p style={{ fontSize: '30px' }}>Contraseña actualizada con éxito!</p>
              </div>
            </div>
          </>
          :
          !loading ?
            <>
              <div className='contenidosForgot'>

                <br />

                <img style={{ width: '300px' }} src={Logo} alt="" />

                {
                  !error ?
                    <>
                      <div style={{ width: '50%', margin: 'auto', padding: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                        <p style={{ fontSize: '30px' }}>Restablece tu contraseña</p>


                        <CFormInput style={{ width: '300px' }} type="password" label="Contraseña Nueva"
                          onChange={(e) => { setPass1(e.target.value) }}
                        />

                        <br />

                        <CFormInput style={{ width: '300px' }} type="password" label='Confirma la Contraseña Nueva'
                          onChange={(e) => { setPass2(e.target.value) }}
                        />
                        <br />
                        {
                          !loading2 ?
                            <><CButton style={{ width: '300px' }} size='lg' color="success" onClick={() => { handleSubmit() }}>Guardar</CButton></>
                            :
                            <><div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div></>
                        }

                      </div>
                    </>
                    :
                    <><p style={{ "fontWeight": "bold", "color": "red", 'padding': '30px' }}>Ocurrio un error, por favor intetenta nuevamente.</p></>
                }

                <center>

                  <div className="container_row">
                    <div className="layer1">
                      <img id='mario' src={mario} alt={"Active Code"} style={{ 'width': "3%", "height": "auto" }} />
                    </div>
                    <div className="layer2">
                      <img src={logoActive} alt={"Active Code"} onClick={logoHandler} style={{ 'width': "8%", "height": "auto" }} />
                    </div>
                  </div>
                </center>

                <br /><br />
              </div>
            </>
            : <><div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div></>
      }
    </>
  );
}

export default ForgotPassword